export const load = () => ({
	title: 'Featured Articles',
	showTitle: true,
});
